/*
  Tile — small labelled metric card used in the round header (Par, Yards,
  Hole, etc). Named-export as `Tile` for grid re-use across the app.
*/
export default function Tile({ label, value, testid }) {
  return (
    <div className="surface-card-flat p-3 text-center" data-testid={testid}>
      <div className="label-uppercase">{label}</div>
      <div className="font-mono-num text-2xl font-black text-[var(--primary)] mt-1">{value}</div>
    </div>
  );
}
